import axios from "axios";

// create an axios instance
const service = axios.create({
	// baseURL: '/', // url = base url + request url
	baseURL: 'https://kubota.nongji1958.com/',
	// withCredentials: true, // send cookies when cross-domain requests
	timeout: 30000, // request timeout
});
service.defaults.withCredentials = false;
// request interceptor
service.interceptors.request.use(
	(config) => {
		// 直播 JWT：统一附带当前登录 token，下单等接口以服务端鉴权用户为准
		const liveToken = localStorage.getItem("live_access_token");
		if (liveToken) {
			config.headers = config.headers || {};
			config.headers.Authorization = `Bearer ${liveToken}`;
		}
		return config;
	},
	(error) => {
		// do something with request error
		console.log(error); // for debug
		return Promise.reject(error);
	}
);

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	(response) => {
		const res = response.data;
		// 如果响应类型是 xlsx 包，则执行下载文件逻辑
		if (response.headers["content-type"] === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
			const disposition = decodeURI(response.headers["content-disposition"]);
			const fileName = disposition.split("=")[1];
			const a = document.createElement("a");
			const blob = new Blob([res], {
				type: "application/vnd.ms-excel",
			});
			const url = URL.createObjectURL(blob);
			a.setAttribute("href", url);
			a.setAttribute("download", fileName);
			a.click();
			return;
		}
		// if the custom code is not 20000, it is judged as an error.
		if (res.code !== 200 && res.code !== 4001)  {
			// Message({
			// 	message: res.message.message,
			// 	type: 'error',
			// 	duration: 5 * 1000,
			// });
			console.error("请求错误", res);

			// 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
			if (res.code === 500 || res.code === 400 || res.code === 404) {
				// to re-login
				// MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
				//   confirmButtonText: 'Re-Login',
				//   cancelButtonText: 'Cancel',
				//   type: 'warning'
				// }).then(() => {
				//   store.dispatch('user/resetToken').then(() => {
				//     location.reload()
				//   })
				// })
			}
			return Promise.reject(new Error(res.message || "Error"));
		} else {
			return res;
		}
	},
	(error) => {
		console.error("err", error); // for debug
		// Message({
		// 	message: error.message,
		// 	type: 'error',
		// 	duration: 5 * 1000,
		// });
		return Promise.reject(error);
	}
);

export default service;
